import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {

  constructor() { }

  contentWords(text: string, words: String[]) {
    text = text.toLowerCase();
    let localWords = [];

    words.forEach(i => {
      localWords.push(i);
    });

    var accentedForms = {
      'c': 'ç',
      'a': 'àáâãä',
      'e': 'èéêë',
      'i': 'ìíîï',
      'o': 'òóôõö',
      'u': 'ùúûü',
      'n': 'ñ',
      'y': 'ýÿ'
    };

    for (var s in accentedForms) {
      for (var i = 0; i < localWords.length; i++) {
        localWords[i] = localWords[i].replace(s, '[' + s + accentedForms[s] + ']');
      };
    }

    //var pattern = "(" + localWords.join("|") + ")";
    let pattern = "(" + localWords.join(".*") + ")";
    //pattern = "\\b" + pattern + "\\b";
    let re = new RegExp(pattern, 'gi');

    //console.log(text, pattern);

    //return text.replace(re, function (match, $1, $2, offset, original) { return '<mark class="highlight">' + $1 + '</mark>'; });
    return re.test(text);
  }

  isNullOrEmpty(s: string): boolean {
    return !s;
  }

  getParameterByName(name, url) {
      if (!url) {
        url = window.location.href;
      }
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/services/utils.service.ts